import { defineMessages } from 'react-intl';

export const chatHeaderMessages: {
	chatHeaderBackButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderMenuButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderNewChatButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderNewAgentChatButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderMoreMenuButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderFeedbackButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderDebugButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderFeedbackIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderGetHelpButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderGetHelpIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderCloseButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderRenameButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderRenameIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderDeleteButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatHeaderDeleteIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	chatHeaderBackButtonLabel: {
		id: 'ai-mate.rovo-chat-header.back-home-button-label',
		defaultMessage: 'Go back to Rovo chat',
		description: 'Label for the header back button',
	},
	chatHeaderMenuButtonLabel: {
		id: 'ai-mate.rovo-chat-header.menu-button-label',
		defaultMessage: 'Menu',
		description: 'Label for the header hamburger menu',
	},
	chatHeaderNewChatButtonLabel: {
		id: 'ai-mate.rovo-chat-header.new-chat-button-label',
		defaultMessage: 'New chat',
		description: 'Label for the header new chat button',
	},
	chatHeaderNewAgentChatButtonLabel: {
		id: 'ai-mate.rovo-chat-header.new-agent-chat-button-label',
		defaultMessage: 'New chat with {agentName}',
		description: 'Label for the header new chat button with agent',
	},
	chatHeaderMoreMenuButtonLabel: {
		id: 'ai-mate.rovo-chat-header.more-menu-button-label',
		defaultMessage: 'More',
		description: 'Label for the header more menu button',
	},
	chatHeaderFeedbackButtonText: {
		id: 'ai-mate.rovo-chat-header.feedback-button-text',
		defaultMessage: 'Feedback',
		description: 'Text for the header feedback button',
	},
	chatHeaderDebugButtonText: {
		id: 'ai-mate.rovo-chat-header.debug-button-label',
		defaultMessage: 'Debug',
		description: 'Label for the header debug button',
	},
	chatHeaderFeedbackIconLabel: {
		id: 'ai-mate.rovo-chat-header.feedback-icon-label',
		defaultMessage: 'Feedback',
		description: 'Label for the header feedback icon',
	},
	chatHeaderGetHelpButtonText: {
		id: 'ai-mate.rovo-chat-header.get-help-button-text',
		defaultMessage: 'Get help',
		description: 'Text for the header get help button',
	},
	chatHeaderGetHelpIconLabel: {
		id: 'ai-mate.rovo-chat-header.get-help-icon-label',
		defaultMessage: 'Get help',
		description: 'Label for the header get help icon',
	},
	chatHeaderCloseButton: {
		id: 'ai-mate.rovo-chat-header.close-chat-header-button-label',
		defaultMessage: 'Close',
		description: 'Label for the header close chat button',
	},
	chatHeaderRenameButtonText: {
		id: 'ai-mate.rovo-chat-header.rename-button-text',
		defaultMessage: 'Rename',
		description: 'Text for the header rename button',
	},
	chatHeaderRenameIconLabel: {
		id: 'ai-mate.rovo-chat-header.rename-icon-label',
		defaultMessage: 'Rename',
		description: 'Label for the header rename icon',
	},
	chatHeaderDeleteButtonText: {
		id: 'ai-mate.rovo-chat-header.delete-button-text',
		defaultMessage: 'Delete',
		description: 'Text for the header delete button',
	},
	chatHeaderDeleteIconLabel: {
		id: 'ai-mate.rovo-chat-header.delete-icon-label',
		defaultMessage: 'Delete',
		description: 'Label for the header delete icon',
	},
});
